export default {
    churchAppAgreementModal: {
        title: `Before you continue...`,
        description: `Once you launch your Church App, <span class="font-bold">members will be able to add themselves</span> to your database and create People profiles that will be reflected within Breeze.`,
        checkboxLabel: `Check this box to confirm you've set the default member role in`,
        roleSettingsLink: `Role Settings`
    }
}
